import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Card, Tabs, Tab, ButtonGroup, Button } from "react-bootstrap";
import { httpGet } from "../../../utility/requestHelper";
import { unifiedEnvConfig } from "../../../constants/api-endpoint";
import { FacebookIcon, FacebookWBIcon, InstagramIcon, InstagramWBIcon, NoFeedIcon, TwitterIcon } from "../../Icons/icons.component";
import {
  INSIGHTTAB,
  INSTATAB,
  VERTICALS,
  APP_CONSTANTS,
  SOCIAL_SOURCES,
  SOCIAL_SOURCES_OPTIONS,
} from "../../../constants/app-constant";
import Loader from "../../Shared/Loader";
import "../../Dashboard/style.sass";
import moment from "moment";
import SingleInsightFeed from "./SingleInsightFeed";
import InsightFeedsModal from "./InsightFeedModal";
import SocialIcon from "../SocialIcon";
const { FACEBOOK, INSTAGRAM, TWITTER, YOUTUBE, PINTEREST,LINKEDIN } = SOCIAL_SOURCES;

const InsightFeeds = ({
  endRange,
  startRange,
  widgetList,
  setTopicId,
  selectedFilter,
  setSelectedFilter,
  tabData,
  setTabData,
  setWidgetApiInProgress,
  widgetApiInProgress,
  setOptList,
  topicList,
  setTopicList,
  channelType
}) => {
  const { V_SOCIAL, V_BLOG, V_FORUM, TWITTER_INSIGHTS } = VERTICALS;
  const [apiInProgress, setApiInProgress] = useState(false);
  const [tabKey, setTabKey] = useState(channelType === INSTAGRAM?INSTATAB[0].toLowerCase():INSIGHTTAB[0].toLowerCase());
  const [vertical, setVertical] = useState(TWITTER_INSIGHTS);
  const [showModal, setShowModal] = useState(false);
  const [feedsToShare, setFeedsToshare] = useState([]);

  const selectedEntity =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.selectedEntity
    ) || null;

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  let tempList = [];
  useEffect(() => {
    if (startRange && endRange && selectedFilter && selectedFilter.value) {
      getInsightFeeds(selectedFilter.value,channelType);
    }
  }, [startRange, endRange]);
  useEffect(() => {
    if (selectedFilter && selectedFilter.value) {
      getInsightFeeds(selectedFilter.value,channelType);
    }
  }, [selectedFilter]);
  const handleSelectedFeeds = (feed) => {
    const selectedElm = feedsToShare.filter((n) => n.id == feed.id);
    if (selectedElm && selectedElm[0]) {
      setFeedsToshare(feedsToShare.filter((n) => n.id != selectedElm[0].id));
    } else {
      setFeedsToshare([...feedsToShare, feed]);
    }
  };

  useEffect(() => {
    const fromDate = moment(startRange).format("MM/DD/YYYY");
    const toDate = moment(endRange).format("MM/DD/YYYY");
    setApiInProgress(true);
    httpGet(
      `${unifiedEnvConfig.FETCH_ALL_TOPICS}?client_id=${selectedClient.id}`
    ).then((res) => {
      setSelectedFilter(
        res.data.data.map(({ name, id }) => {
          return {
            value: id,
            label: name,
          };
        })[0]
      );
      setTopicList(res.data.data);
      setTopicId(res.data.data.map(({ id }) => id)[0]);
      setWidgetApiInProgress(true);
      setApiInProgress(false);
    });
  }, []);

  useEffect(() => {
    if (selectedFilter) {
      const id = topicList.filter(({ id }) => {
        if (id === selectedFilter.value) {
          return id;
        }
      });
      setTopicId(id.map(({ id }) => id));
    }
  }, [selectedFilter]);

  useEffect(() => {
    setOptList(
      topicList.length &&
        topicList.map(({ name, id }) => {
          return {
            value: id,
            label: name,
          };
        })
    );
  }, [topicList]);

  const renderTabData = () => {
    return (channelType === INSTAGRAM?INSTATAB:INSIGHTTAB).map((item1, index) => {
      const allArticleList =
        selectedFilter &&
        tabData.map(
          (e) =>
            `${SOCIAL_SOURCES.LINKEDIN}/${e.id}?entityName="${selectedFilter.label}"`
        );

      if (tabData) {
        return (
          <Tab
            key={index}
            eventKey={item1.toLowerCase()}
            title={`${item1}`}
            className="cardTopab"
          >
            {tabData && tabData.length ? (
              <>
                {tabData
                  .map((item, idx) => {
                    return (
                      <SingleInsightFeed
                        key={item.id}
                        {...item}
                        checked={false}
                        topicType={vertical}
                        onFeedSelect={handleSelectedFeeds}
                        selectedVertical={vertical}
                        clientId={selectedClient.id}
                        feedsToShare={feedsToShare}
                        allArticleList={allArticleList}
                        selectedFilter={selectedFilter}
                        ChannelType={channelType}
                      />
                    );
                  })
                  .slice(0, 2)}
                {tabData.length > 2 ? renderViewAll() : null}
              </>
            ) : (
              <div
                className="noFilterDataWrap no-feeds"
                style={{ width: "100%" }}
              >
                <NoFeedIcon size="sm" />
                <h6>No Feeds Found</h6>
              </div>
            )}
          </Tab>
        );
      }
    });
  };

  const getInsightFeeds = (topicId,channelId) => {
    const fromDate = moment(startRange).format("MM/DD/YYYY");
    const toDate = moment(endRange).format("MM/DD/YYYY");
    setApiInProgress(true);
    if (topicId) {
      httpGet(
        `${unifiedEnvConfig.INSIGHT_FEEDS}?topic_id=${topicId}&client_id=${selectedClient.id}&channel_id=${channelId}&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}`
        // `https://cbiu.weboapps.com?topic_id=${27}&client_id=${
        //   selectedClient.id
        // }&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}`
      )
        .then((response) => {
          setApiInProgress(false);
          const {
            data: { data },
          } = response;
          setTabData(data);
        })
        .catch((e) => {
          if (e.message == APP_CONSTANTS.API_CANCEL_ERROR_TEXT) {
            setApiInProgress(true);
          } else {
            setApiInProgress(false);
          }
        });
    }

    //Pagination topRetweet may required in future..

    // if (topicId) {
    //   httpGet(
    //     `${unifiedEnvConfig.TWITTER_FEEDS}?client_id=${selectedClient.id}&searchParams[from_date]=${fromDate}&searchParams[to_date]=${toDate}&searchParams[page]=10&searchParams[perPage]=1&topic_id=${topicId}`
    //   )
    //     .then((response) => {
    //       setApiInProgress(false);
    //       const {
    //         data: { data },
    //       } = response;
    //       // setTabData(data);
    //       // console.log(data);
    //     })
    //     .catch((e) => {
    //       if (e.message == APP_CONSTANTS.API_CANCEL_ERROR_TEXT) {
    //         setApiInProgress(true);
    //       } else {
    //         setApiInProgress(false);
    //       }
    //     });
    // }
  };

  const renderViewAll = () => {
    return (
      <div className="view-all-button" onClick={() => setShowModal(true)}>
        View All
      </div>
    );
  };

  const setVerticalValue = (topic) => {
    setVertical((prevState) => parseInt(topic, 10));
  };

  const handleVerticalClick = (verticalValue) => {
    if (verticalValue) {
      setFeedsToshare([]);
      setVerticalValue(verticalValue);
      setTabKey(channelType === INSTAGRAM?INSTATAB[0].toLowerCase():INSIGHTTAB[0].toLowerCase());

      setApiInProgress(false);
    }
  };

  const handleTabClick = (tab) => {
    setFeedsToshare([]);
    setTabKey(tab);
  };

  return (
    <>
      {/* {dropDown()} */}
      {showModal && selectedClient.id ? (
        <InsightFeedsModal
          show={showModal}
          onCancel={setShowModal}
          clientId={selectedClient.id}
          handleTabClick={handleTabClick}
          handleVerticalClick={handleVerticalClick}
          selectedVertical={vertical}
          selectedTabKey={tabKey}
          tabData={tabData}
          startRange={startRange}
          endRange={endRange}
          selectedFilter={selectedFilter}
          topicId={selectedFilter.value}
          channelType={channelType}
        />
      ) : null}
      <Card className="cardWrap cls-tfa" body>
        <div className="cardTopa">
          <ButtonGroup
            className="smallToggleBtnGroup"
            onClick={(e) => handleVerticalClick(e.target.value)}
          >
            <Button
              className={
                vertical === TWITTER_INSIGHTS ? "tagBlue active" : "tagBlue"
              }
              value={TWITTER_INSIGHTS}
            >
              {/* <SocialIcon type={channelType} /> */}
              {channelType === LINKEDIN?
                <SocialIcon type={channelType} />
                :(
                  channelType === FACEBOOK?
                    <FacebookWBIcon cla={"icon-place"} />
                    :(<InstagramWBIcon cla={"icon-place"} />))}
              {channelType && SOCIAL_SOURCES_OPTIONS.filter(data => Number(data.value) === Number(channelType))[0].label}
            </Button>
          </ButtonGroup>
          {/* <ShareArticle
            article={feedsToShare}
            isSocial={vertical === TWITTER_INSIGHTS}
            onShareSuccess={() => setFeedsToshare([])}
          /> */}
        </div>
        {
          <React.Fragment key={tabKey}>
            {apiInProgress ? (
              <Loader />
            ) : (
              <>
                <Tabs
                  activeKey={tabKey}
                  transition={false}
                  onSelect={(k) => handleTabClick(k)}
                  className="cardTopab"
                >
                  {renderTabData()}
                </Tabs>
              </>
            )}
          </React.Fragment>
        }
      </Card>
    </>
  );
};

export default InsightFeeds;
